// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_mb-0";